import React from 'react';

import { usePageTitle } from '../../utils/hooks/usePageTitle';
import { useMetaTags } from '../../utils/hooks/useMetaTags';
import PageTitleLayout from '../../uiKit/pageTitleLayout';
import { useTranslation } from 'react-i18next';
import ReferralForm from '../forms/referralForm';

export default function ReferralPage() {
  const { t } = useTranslation('common');

  return (
    <>
      <div className={'w-full bg-black flex flex-col items-center'}>
        <PageTitleLayout title={'Referral Program'}
                         className={'w-full flex flex-col items-center gap-8 pt-10 pb-32 px-4 mt-24 md:mt-48 max-w-7xl'}
                         classNameTitle={'md:!text-8xl'}>
        </PageTitleLayout>
      </div>

      <div
        className={'w-full flex flex-col gap-12 max-w-4xl py-32 px-4 md:px-16 [&_ol]:!list-decimal [&_ol]:p-[revert] [&_ul]:p-[revert] [&_ul]:!list-disc'}>
        <ReferralForm />
      </div>
    </>
  );
}
